import React, { useRef, useState } from 'react';
import { Input, Modal } from 'antd';
import type { InputRef } from 'antd';

// ─────────────────────────────────────────────────────────────
// PaddockNewNameModal
// Step 1 of the "New Paddock" flow — enter the paddock name
// before drawing.
// ─────────────────────────────────────────────────────────────

interface Props {
  onConfirm: (name: string) => void;
  onCancel: () => void;
}

const PaddockNewNameModal = ({ onConfirm, onCancel }: Props) => {
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const inputRef = useRef<InputRef>(null);

  const handleAfterOpen = (open: boolean) => {
    if (!open) return;
    inputRef.current?.input?.focus();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
    if (error) setError(null);
  };

  const handleConfirm = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError('Paddock name cannot be empty.');
      return;
    }
    onConfirm(trimmed);
  };

  return (
    <Modal
      open
      title="New Paddock"
      okText="Next"
      cancelText="Cancel"
      onOk={handleConfirm}
      onCancel={onCancel}
      mask={{ closable: false }}
      destroyOnHidden
      afterOpenChange={handleAfterOpen}
    >
      <div className="mt-2">
        <Input
          ref={inputRef}
          value={name}
          onChange={handleChange}
          onPressEnter={handleConfirm}
          allowClear
          status={error ? 'error' : undefined}
          placeholder="Paddock name"
        />
        {error && (
          <p className="mt-1.5 text-xs text-red-500">{error}</p>
        )}
      </div>
    </Modal>
  );
};

export default PaddockNewNameModal;
